import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialogRef as MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { Project } from '../../../../../../../../../shared/models';
import { CommonService } from '../../../../../../../../../shared/services/common.service';
import { CreateEquipmentLookupRequest } from '../../../../../../../core/projects.actions';
import * as fromRoot from '../../../../../../../../../state/app.state';

@Component({
    selector: 'app-equipment-setup-popup',
    templateUrl: './equipment-setup-popup.component.html',
    styleUrls: ['./equipment-setup-popup.component.scss'],
    standalone: false
})
export class EquipmentSetupPopupComponent implements OnInit {
  public project: Project;
  public item: any;
  public form: FormGroup<any>;
  public errorMessages: any = {};
  public errorMessageMap = {
    name: {
      required: 'This field is required.',
    },
  };

  constructor(
    private commonService: CommonService,
    private store: Store<fromRoot.State>,
    public dialogRef: MatDialogRef<EquipmentSetupPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { project: Project; item?: any }
  ) {
    this.project = data.project;
    this.item = data.item;
    
    this.form = new FormGroup<any>({
      name: new FormControl({ value: this.item?.name || this.item?.value || '', disabled: false }, [Validators.required]),
    });
  }

  ngOnInit(): void {}

  checkForErrors(currentField?: string): void {
    this.errorMessages = {
      ...this.errorMessages,
      ...(this.commonService.checkFormValidation(this.form, this.errorMessageMap, currentField)),
    };
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    if (this.form.valid) {
      const payload = {
        projectId: this.project.id,
        body: {
          value: this.form.value.name,
          ...(this.item?.id && { id: this.item.id }),
        },
      };
      this.store.dispatch(CreateEquipmentLookupRequest({ payload }));
      this.dialogRef.close(this.form.value);
    } else {
      this.checkForErrors();
    }
  }
}

